<template>
  <transition
    appear
    name="fade"
  >
    <div
      v-if="visible"
      :class="{'mouse-wheel-animation--absolute': isFirefox}"
      class="mouse-wheel-animation text-light"
      @click="visible = false"
    >
      <div class="mouse-wheel-animation__mouse">
        <div class="mouse-wheel-animation__scroll" />
      </div>
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MouseWheelAnimation',
  props: {
    duration: {
      type: Number,
      default: 8000,
    },
  },
  data () {
    return {
      visible: false,
    }
  },

  computed: {
    isFirefox () {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    },
  },

  mounted () {
    if (this.isTouchDevice() || window.scrollY >= window.innerHeight) {
      return
    }

    this.initListeners()

    this.IntersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          this.visible = false
          clearTimeout(this.initTimeout)
          clearTimeout(this.timeout)
          this.IntersectionObserver.disconnect()
        }
      })
    }, { threshold: [0.15], root: null })

    if (this.$el.parentNode.nextElementSibling && !this.isFirefox) {
      this.$nextTick(() => {
        this.IntersectionObserver.observe(this.$el.parentNode.nextElementSibling)
      })
    }
  },

  methods: {
    initListeners () {
      this.initTimeout = setTimeout(() => {
        this.visible = true
      }, 1000)

      this.timeout = setTimeout(() => {
        this.visible = false
        this.IntersectionObserver && this.IntersectionObserver.disconnect()
      }, this.duration)
    },

    isTouchDevice () {
      return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
    },
  },

  beforeDestory () {
    this.initTimeout && clearTimeout(this.initTimeout)
    this.IntersectionObserver && this.IntersectionObserver.disconnect()
    this.timeout && clearTimeout(this.timeout)
  },
}
</script>
